import React from "react";
import { SectionHeading } from "@/components/PackSelection";
import { BeforeAfter } from "@/components/BeforeAfter";

const CDN = "https://static.prod-images.emergentagent.com/jobs/86773c59-3614-477d-9c71-250b0d9699a5/images";

const RESULTS = [
  {
    name: "Routine hydratation",
    before: `${CDN}/69a857d63b9c00ed2b9416672ddf7dacf1140d9ba355e4bafbd428a4420d748f.jpeg`,
    after: `${CDN}/d4bbf7c37ab24cfed66d1d5221adafe78ea849636a586acc846c695f6898f3c5.jpeg`,
    caption: "Des boucles plus définies et brillantes après une routine régulière.",
  },
  {
    name: "Nutrition & volume",
    before: `${CDN}/f9babfbc4f7518e956eb7c14c82560f2843e4f3416b8de01e430d71b27b29f5c.jpeg`,
    after: `${CDN}/32c8051be575b3975b79a562fd5f2b7ead0f6a89393ee65b15b8474da75bff1c.jpeg`,
    caption: "Plus de volume et de souplesse grâce aux soins nourrissants.",
  },
  {
    name: "Force & longueur",
    before: `${CDN}/1a8d1f8b37210126f3799d1eaf2a8e91de3f8500ba0e407b3809e389baa32aa1.jpeg`,
    after: `${CDN}/89a205b04ee87cd41563abe5f2a260c3ff7522f7b3f3a5931cba78014f64de07.jpeg`,
    caption: "Des cheveux visiblement plus forts et plus longs au fil des semaines.",
  },
];

export const ResultsGallery = () => (
  <section id="resultats" className="bg-[var(--oz-bg-2)] scroll-mt-20">
    <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-16 md:py-24">
      <SectionHeading eyebrow="Avant / Après" title="Des résultats qui parlent" />
      <p className="-mt-6 mb-10 text-center text-sm text-[var(--oz-muted)] max-w-2xl mx-auto">
        Glissez le curseur sur chaque photo pour voir la transformation. Les résultats varient selon
        les personnes, la nature des cheveux et la régularité de la routine.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
        {RESULTS.map((r, i) => (
          <div key={i} data-testid={`result-card-${i}`}>
            <BeforeAfter before={r.before} after={r.after} alt={r.name} testId={`before-after-${i}`} />
            <h3 className="mt-4 font-serif text-lg text-[var(--oz-text)]">{r.name}</h3>
            <p className="mt-1 text-sm text-[var(--oz-muted)] leading-relaxed">{r.caption}</p>
          </div>
        ))}
      </div>

      <p className="mt-8 text-center text-xs text-[var(--oz-muted)] italic">
        Photos d'illustration. Aucun résultat n'est garanti — les effets dépendent de chaque personne.
      </p>
    </div>
  </section>
);

export default ResultsGallery;
